import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import InstallButton from "@/components/InstallButton";
import { DeviceMobile, Export, DotsThreeVertical } from "@phosphor-icons/react";

const KEY = "hgs_install_guide_v1";

export default function InstallGuide() {
  const [open, setOpen] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    try {
      const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
      if (standalone || localStorage.getItem(KEY)) return;
      const ua = navigator.userAgent || "";
      const isMobile = /android|iphone|ipad|ipod/i.test(ua);
      if (!isMobile) return;  // pe desktop nu deranjăm — instalarea se face din pagina Companion
      setIos(/iphone|ipad|ipod/i.test(ua));
      const t = setTimeout(() => setOpen(true), 1200);
      return () => clearTimeout(t);
    } catch (e) { /* noop */ }
  }, []);

  const close = () => {
    try { localStorage.setItem(KEY, "1"); } catch (e) { /* noop */ }
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) close(); }}>
      <DialogContent className="max-w-md" data-testid="install-guide">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <DeviceMobile size={22} weight="fill" className="text-primary" /> Instalează Highberg pe telefon
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Adaugă aplicația pe ecranul principal ca să primești notificări native — chiar și cu aplicația închisă.
        </p>
        {ios ? (
          <ol className="mt-2 space-y-2 text-sm">
            <li>1. În Safari, apasă butonul <span className="inline-flex items-center gap-1 font-semibold"><Export size={16} /> Partajează</span>.</li>
            <li>2. Alege <b>„Adaugă pe ecranul principal"</b>.</li>
            <li>3. Deschide Highberg de pe ecranul principal și apasă 🔔 <b>Activează</b> în clopoțel.</li>
          </ol>
        ) : (
          <ol className="mt-2 space-y-2 text-sm">
            <li>1. În Chrome, apasă meniul <span className="inline-flex items-center gap-1 font-semibold"><DotsThreeVertical size={16} /> (⋮)</span> sus-dreapta.</li>
            <li>2. Alege <b>„Instalează aplicația"</b> / „Adaugă pe ecranul principal".</li>
            <li>3. Deschide Highberg și apasă 🔔 <b>Activează</b> în clopoțel.</li>
          </ol>
        )}
        {!ios && <InstallButton className="mt-3" />}
        <DialogFooter>
          <Button variant="ghost" onClick={close} data-testid="install-guide-later">Mai târziu</Button>
          <Button onClick={close} data-testid="install-guide-ok">Am înțeles</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
